<template>
  <v-container fluid class="pa-0">
    <v-card outlined class="my-3">
      <v-card-title style="padding: 0.5rem 1rem">
        <v-row @click="setExpanded" style="cursor: pointer" no-gutters>
          <v-col cols="4"
            ><v-icon>{{
              isExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down'
            }}</v-icon>
            {{ $t('Filtras') }}</v-col
          >
        </v-row>
      </v-card-title>
      <v-expand-transition>
        <v-card-text class="pt-1" v-if="isExpanded">
          <form @keydown.enter.prevent="submit()">
            <v-row class="mb-0 pb-0">
              <v-col cols="12" md="6">
                <el-date-picker
                  append-icon="mdi-account"
                  autocomplete="off"
                  name="date_from"
                  v-model="mainData['created_at-search-from']"
                  tooltip="Ireg. Pagrindinis. Administravimas. Sisteminiai įrašai. Data nuo"
                  label="Data nuo"
                  type="text"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  append-icon="mdi-account"
                  autocomplete="off"
                  name="date_to"
                  v-model="mainData['created_at-search-to']"
                  tooltip="Ireg. Pagrindinis. Administravimas. Sisteminiai įrašai. Data iki"
                  label="Data iki"
                  type="text"
                />
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <el-button
                  class="mr-1"
                  title="Ieškoti"
                  :loading="loading"
                  color="primary"
                  icon="ieškoti"
                  @click.native.stop="beforeSearch()"
                />
                <el-report-btn @downloadReport="downloadReport" object="error-logs" :loading="loading" :reportData="reportData"  />
                <el-button
                  color="secondary"
                  icon="išvalyti"
                  title="Išvalyti"
                  :loading="loading"
                  @click.native="clearData()"
                />
              </v-col>
            </v-row>
          </form>
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AdminRecordsSearch',
  props: {
    loading: Boolean,
  },
  data: () => ({
    mainData: {},
    reportData: {},
  }),
  computed: {
    ...mapGetters(['searchParams']),
    isExpanded() {
      if (this.mainData.isExpanded == null) {
        this.$set(this.mainData, 'isExpanded', false)
      }
      return this.mainData.isExpanded
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getSearchParams()
    this.searchData()
  },
  methods: {
    downloadReport() {
      this.$emit('downloadReport')
    },
    setExpanded() {
      let logic = !this.mainData.isExpanded
      this.$set(this.mainData, 'isExpanded', logic)
    },
    getSearchParams() {
      if (this.searchParams && this.searchParams.route === this.$route.name) {
        this.mainData = this.searchParams.mainData
      }
    },
    searchData() {
      let searchData = { ...this.mainData }
      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
      })
      this.reportData = { ...this.mainData }
      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {isExpanded: true, clear: true }
      this.$nextTick(() => {
        this.mainData = { isExpanded: true }
        this.searchData()
      })
    },
    submit() {
      this.beforeSearch()
    },
     beforeSearch() {
      this.$validator.validateAll().then((res) => {
        if (res) {
          this.searchData(true)
        } 
      })
    },
  },
}
</script>
